import { Component, AfterViewInit, ViewChild, ElementRef, Input, SimpleChanges, Output, EventEmitter, OnInit, OnDestroy, OnChanges, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Campus } from 'src/app/models/campus.model';
import { Family } from 'src/app/models/family.model';
import { Notice } from 'src/app/models/notice.model';
import { School } from 'src/app/models/school.model';
import { Section } from 'src/app/models/section.model';
import { Image } from 'src/app/models/image';
import { EscolarService } from 'src/app/services/escolar.service';
import { FileValidationService } from 'src/app/services/file-validation.service';
import { SecureStorageService } from 'src/app/services/secure-storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { environment } from 'src/environments/environment';
import { ModalImageGeneratorComponent } from '../modals/modal-image-generator.component';

// Interfaces for type safety
interface DropdownItem {
  item_id: number;
  item_text: string;
}

interface DropdownSettings {
  singleSelection: boolean;
  idField: string;
  textField: string;
  selectAllText: string;
  unSelectAllText: string;
  itemsShowLimit: number;
  allowSearchFilter: boolean;
}

interface GenericType {
  id: number;
  title: string;
}

interface FileUpload {
  id?: number;
  name: string;
  type: string;
  content_type?: string;
  size: number;
  data?: string | ArrayBuffer | null;
  url?: string;
  isExisting?: boolean;
}

interface ExistingImage {
  id?: number;
  url?: string;
  name?: string;
  type?: string;
  data?: string;
  size?: number;
  isExisting?: boolean;
  hasError?: boolean;
  originalUrl?: string;
}

interface FormControls {
  [key: string]: AbstractControl;
}

interface ServiceResponse<T> {
  data: T;
  message?: string;
  error?: string;
}

interface MediumEditorOptions {
  toolbar?: {
    buttons: string[];
    diffLeft?: number;
    diffTop?: number;
  };
  placeholder?: {
    text: string;
  };
}

interface HttpError {
  error?: {
    message?: string;
  };
  message?: string;
  status?: number;
}

interface DeleteResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

@Component({
  selector: 'app-form-notice',
  template: `
    <form [formGroup]="noticeForm">    
      <div class="d-flex flex-wrap flex-md-nowrap py-2">
        
        <div class="flex-shrink-1  d-block d-sm-none d-md-block px-3 py-2"  style="min-width: 414px; max-width: 414px; width: 414px; max-height: 660px;">
          <!-- button type="button" class="btn btn-sm btn-outline-secondary" (click)="openModalImageGenerator()">
            <fa-icon [icon]="icons.faWandMagicSparkles" class="me-2"></fa-icon>
            Crea tu propia imagen
          </button>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-primary">Left</button>
            <button type="button" class="btn btn-primary">Middle</button>
            <button type="button" class="btn btn-primary">Right</button>
          </div -->
          <div class="d-flex flex-column flex-wrap rounded-4" [ngStyle]="{ 'background-color': school ? school.color : '#fff'  }">
            <div class="d-flex">
              <div class="mt-3">
                <div class="d-flex flex-wrap" *ngIf="ff['generic_type']?.value == 1">
                  <div class="bg-primary text-center rounded-3 float-start ms-3 me-2" style="width: 28px; height: 28px; padding-top: 2px;">
                    <fa-icon [icon]="icons.faStar" class="text-white text-center"></fa-icon>
                  </div>
                  <div class="float-start text-w500 pt-1">Escuela</div>
                </div>
                <div class="d-flex" *ngIf="ff['generic_type']?.value == 3">
                  <div class="bg-primary text-center rounded-3 float-start ms-3 me-2" style="width: 28px; height: 28px; padding-top: 2px;">
                    <fa-icon [icon]="icons.faStar" class="text-white text-center"></fa-icon>
                  </div>
                  <div class="float-start text-w500 pt-1">Grupo</div>
                </div>
                <div class="d-flex" *ngIf="ff['generic_type']?.value == 5">
                  <div class="bg-primary text-center rounded-3 float-start ms-3 me-2" style="width: 28px; height: 28px; padding-top: 2px;">
                    <fa-icon [icon]="icons.faStar" class="text-white text-center"></fa-icon>
                  </div>
                  <div class="float-start text-w500 pt-1">Familia</div>
                </div>
              </div>            
            </div>
            <div class="d-flex mt-2 ms-3">
              <h3 class="text-dark">{{ff['title'].value}}</h3>
            </div>
            <div class="d-flex" *ngIf="notice?.images!.length>0" style="max-width: 420px;">
              <ngb-carousel
                [showNavigationArrows]="false"
                [showNavigationIndicators]="true"
              >
                <ng-template ngbSlide *ngFor="let file of ff['images']?.value">
                  <div class="picsum-img-wrapper">
                    <img src="{{file.data}}" alt="Random first slide" width="420px" />
                  </div>
                </ng-template>
              </ngb-carousel>
            </div>
            <div class="d-flex mt-4 ms-3" style="max-width: 414px;">
              <div class="text-sm" [innerHTML]="ff['description'].value"></div>
            </div>
          </div>
        </div>
        <div class="flex-fill ps-4" *ngIf="loading">
          <div class="text-center my-5 py-5">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-dark"></fa-icon>
            <h5>CARGANDO...</h5> 
          </div>
        </div>
        <div class="flex-fill ms-0 ms-md-4" *ngIf="!loading">
          <!-- div class="form-group mt-0 mb-3">
            <div class="d-flex">
              <div class="ms-auto"></div>
              <div class="flex-fill text-end">
                <p class="text-secondary text-end text-muted text-sm mb-0">Capacidad max. {{totalSize | number : '1.0-2'}} MB / {{maxCapacity}} MB</p>
                <div class="progress">
                  <div class="progress-bar bg-info" role="progressbar" [ngStyle]="{ width: usedPercentage+'%' }" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </!-->          
          <div class="w-100">
            <div class="dropzone rounded-4" appFileDragDrop (filesChangeEmiter)="onFileChange($event)">
              <div class="text-wrapper">
                <div class="centered">
                  <input type="file" name="file" id="file" (change)="onFileChange($event)" multiple accept="image/*, application/pdf, video/*" >
                  <label for="file">
                    <fa-icon [icon]="icons.faImage" class="text-secondary" size="2x"></fa-icon>
                    <br>
                    Arrastra y suelta tu archivo aquí, ó <span class="textLink">selecciona tu archivo</span>
                    <br> <div class="text-sm text-secondary mt-2">Tamaño máximo 10MB</div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="list-group rounded-4 mt-3 mb-3" *ngIf="ff['images'].value.length>0">
            <div class="list-group-item list-group-item-secondary px-3 py-2" *ngFor="let f of ff['images'].value; let ind = index">
              <div class="d-flex">
                <div class="text-center fileItemIconDiv me-2">
                  <div class="mt-2" *ngIf="!f.type?.includes('image')">
                    <fa-icon [icon]="icons.faFilePdf" class="text-secondary" size="2x" *ngIf="f.type?.includes('pdf')"></fa-icon>
                    <fa-icon [icon]="icons.faPlay" class="text-secondary" size="2x" *ngIf="f.type?.includes('video')"></fa-icon>
                  </div>
                  <img [src]="f.data" width="40px" class="mt-1" *ngIf="f.type?.includes('image')">
                </div>
                <div class="flex-fill fileItemText text-start">
                  <p class="mb-0">{{f.name}}</p>
                  <p class="mb-0 text-sm">{{getTotalSize(f.size)}} <span class="text-muted">{{f.type}}</span></p>
                </div>
                <div class="ms-auto">
                  <button type="button" class="btn btn-link">
                    <fa-icon [icon]="icons.faTrashAlt" class="text-secondary" (click)="removeFile(f)"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="generic_type" class="form-control-label text-dark mb-1 ms-2">¿A quien va dirigido?</label>
            <select class="form-select rounded-3 border-secondary" formControlName="generic_type" (change)="selectType($event)">
              <option value="0" selected disabled>Selecciona...</option>
              <option *ngFor="let type of generic_types" [value]="type.id" [selected]="type.id === ff['generic_type'].value">{{type.title}}</option>
            </select>
          </div>
          <div class="form-group mt-3" *ngIf="ff['generic_type'].value != 1">
            <label for="generic_id" class="form-control-label mb-1 ms-2 text-dark">Selecciona los destinatarios</label>
            <div *ngIf="dropdownList.length>0&&!loadingIds">
              <ng-multiselect-dropdown
                [settings]="dropdownSettings"
                [data]="dropdownList"
                [(ngModel)]="selectedItems"
                (onSelect)="onItemSelect($event)"
                (onSelectAll)="onSelectAll($event)"
                class="border-secondary"
                [ngModelOptions]="{standalone: true}"
              >
              </ng-multiselect-dropdown>
            </div>
            <div class="ms-2 mt-1" *ngIf="loadingIds">
              <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="text-dark"></fa-icon>
              <span class="text-muted text-sm ms-2">Cargando información...</span>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="title" class="form-control-label text-dark mb-1 ms-2">Título</label>
            <input type="text" formControlName="title" class="form-control rounded-3 border-secondary" />
          </div>
          <div class="form-group mt-3">
            <label for="description" class="form-control-label text-dark mb-1 ms-2">Descripción (opcional)</label>
            <!-- textarea formControlName="description" class="form-control rounded-3 border-secondary" rows="2"></!-->
            <div appMediumEditor [appMediumEditor]="editorOptions" class="form-control" formControlName="description"></div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-3">
        <div class="form-group text-start">
          <label for="published_at" class="form-check-label text-dark ms-2">Fecha de publicación</label>
          <input type="date" class="form-control rounded-3 bg-transparent border-secondary" formControlName="published_at_date">
        </div>
        <div class="from-group text-start ms-3 mb-0 clearfix">
          <label for="published_at" class="form-check-label text-dark ms-2">Hora de publicación</label>
          <input type="time" class="form-control rounded-3 bg-transparent border-secondary" formControlName="published_at_time">
        </div>
        <div class="flex-fill form-group text-end mt-4 mb-0">
          <div class="form-check form-switch float-end ms-3">
            <label class="text-w500 text-sm pt-1" for="flexSwitchCheckDefault"><fa-icon [icon]="icons.faCircleInfo"></fa-icon></label>              
            <input class="form-check-input form-check-input-lg me-3" type="checkbox" role="switch" id="flexSwitchCheckDefault" formControlName="notify">              
          </div>
          <div ngbDropdown class="d-inline-block">
            <button type="button" class="btn btn-escalas" id="dropdownBasic1" ngbDropdownToggle>
              Guardar <fa-icon [icon]="icons.faChevronDown" class="ms-2"></fa-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button type="button" ngbDropdownItem (click)="noticePublish()">
                <fa-icon [icon]="icons.faPaperPlane" class="me-2"></fa-icon> 
                Publicar
              </button>
              <button type="button" ngbDropdownItem *ngIf="notice?.live">
                <fa-icon [icon]="icons.faSave" class="me-2"></fa-icon>
                Enviar a borrador
              </button>
              <button type="button" class="text-danger" ngbDropdownItem (click)="deleteNotice()">
                <fa-icon [icon]="icons.faTrashAlt" class="me-2"></fa-icon>
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <app-modal-image-generator #modalImageGenerator></app-modal-image-generator>
    
    <ng-template #modalImageGeneratorTemplate>
      <!-- Modal content for image generator -->
    </ng-template>
  `,
  styleUrls: []
})

export class FormNoticeComponent implements OnInit, OnDestroy, OnChanges {
  @Input() notice: Notice | null = null;
  @Input() school: School | null = null;
  @Input() campuses: Campus[] = [];
  @Input() loading: boolean = false;
  @Input('appMediumEditor') options: MediumEditorOptions = {};
  @Output() noticeData = new EventEmitter<Notice>();
  @ViewChild(ModalImageGeneratorComponent, { static: false }) modalImageGenerator !: ModalImageGeneratorComponent;
  @ViewChild('modalImageGenerator', { static: false }) modalImageGeneratorTemplate !: TemplateRef<void>;

  // ✅ Subscription management for memory leak prevention
  private readonly subscriptions = new Subscription();

  escalasURI: string = environment.ESCALAS_WSPREFIX;
  noticeForm: FormGroup = new FormGroup({});

  // ✅ URL joining utility to prevent double slashes
  private joinURL(baseURL: string, path: string | undefined): string {
    if (!path) return baseURL;
    const base = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
    const pathPart = path.startsWith('/') ? path : '/' + path;
    return base + pathPart;
  }

  public uploadedFiles: FileUpload[] = [];
  public files: FileUpload[] = [];

  sections: Section[] = [];
  families: Family[] = [];

  loadingIds: boolean = false;
  dropdownSettings: DropdownSettings = {} as DropdownSettings;
  selectedItems: DropdownItem[] = [];
  dropdownList: DropdownItem[] = [];

  image: string = '';
  hasMedia: boolean = false;
  usedPercentage: number = 0;
  totalSize: number = 0;
  maxCapacity: number = 10;

  // ✅ Additional properties for image management
  existingImages: ExistingImage[] = [];
  newImages: FileUpload[] = [];

  editorOptions = {
    placeholder: {
      text: 'Agrega un texto...'
    },
    toolbar: {
      allowMultiParagraphSelection: true,
      buttons: ['bold', 'italic', 'underline', 'h2', 'h3', 'quote', 'anchor', 'orderedlist', 'unorderedlist'],
      diffLeft: 0,
      diffTop: -10,
      firstButtonClass: 'medium-editor-button-first',
      lastButtonClass: 'medium-editor-button-last',
      relativeContainer: null,
      standardizeSelectionStart: false,
      static: false,
      align: 'center',
      sticky: false,
      updateOnEmptySelection: false
    },
    anchorPreview: {
      hideDelay: 500,
      previewValueSelector: 'a'
    },
    paste: {
      forcePlainText: true,
      cleanPastedHTML: false,
      cleanReplacements: [],
      cleanAttrs: ['class', 'style', 'dir'],
      cleanTags: ['meta'],
      unwrapTags: []
    },
    autoLink: true,
    imageDragging: false
  };

  generic_types: GenericType[] = [
    { id: 1, title: "Todos" },
    { id: 3, title: "Grupo" },
    { id: 5, title: "Familia"}
  ];

  constructor(
    public icons: IconsService,
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly escolarService: EscolarService,
    private readonly imageService: ImageService,
    private readonly store: EscolarService,
    private readonly router: Router,
    private readonly fileValidationService: FileValidationService,
    private readonly secureStorage: SecureStorageService
  ) { }

  ngOnInit(): void {
    this.loadForm();
    this.loadUserSchoolId();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Seleccionar Todo',
      unSelectAllText: 'Deseleccionar Todo',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Log campuses when they change
    if (changes?.['campuses']) {
      console.log('Campuses changed:', changes['campuses'].currentValue);
    }
    
    if (changes?.['notice']?.currentValue) {
      let notice: Notice = changes['notice'].currentValue;
      this.hasMedia = !!(notice.images && notice.images.length > 0);
      this.noticeForm.patchValue({
        notice_id: notice.notice_id,
        title: notice.title,
        description: notice.description,
        notify: notice.notify,
        campus_id: notice.campus_id,
        live: notice.live,
        generic_type: notice.generic_type,
        generic_id: notice.generic_id,
        notice_type: notice.notice_type,
      });

      if (notice.generic_type) {
        this.loadTypes(notice.generic_type);
      }

      // ✅ FIXED: Replace dangerous async map with proper Promise handling
      if (notice.images && notice.images.length > 0) {
        this.loadExistingImages(notice.images);
      }

      this.noticeForm.patchValue({
        images: this.uploadedFiles
      });

      console.log("NOTICE IMAGES ===> ", this.files);
    }
  }

  get ff (): FormControls {
    return this.noticeForm.controls;
  }

  loadSelectedItems(notice: Notice) {
    if (!notice) return;
    const genericIds = notice.generic_id.split(',').map((id: string) => Number.parseInt(id, 10));

    if (notice.generic_type === 3) {
      this.selectedItems.push(
        ...genericIds.map((id: number) => {
          const section = this.sections.find((s: Section) => s.section_id === id);
          return section
            ? { item_id: section.section_id, item_text: `${section?.section || ''} ${section?.grade || ''} ${section?.group || ''}` }
            : null;
        }).filter((item: DropdownItem | null): item is DropdownItem => item !== null)
      );
    } else if (notice.generic_type === 5) {
      this.selectedItems.push(
        ...genericIds.map((id: number) => {
          const family = this.families.find((s: Family) => s.family_id === id);
          return family
            ? { item_id: family.family_id, item_text: family.name }
            : null;
        }).filter((item: DropdownItem | null): item is DropdownItem => item !== null)
      );
    }    
  }

  isImage(file: { content_type: string }): boolean {
    return file.content_type?.startsWith('image/');
  }

  isVideo(file: { content_type: string }): boolean {
    return file.content_type?.startsWith('video/');
  }

  isPdf(file: { content_type: string }): boolean {
    return file.content_type === 'application/pdf';
  }

  getTotalSize(size: number): string {
    return size > 1000000 ? (size / 1000000).toFixed(2) + ' MB' : (size / 1000).toFixed(2) + ' KB';
  }

  selectType(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target) {
      this.loadTypes(Number(target.value));
    }
  }

  // ✅ FIXED: Proper async image loading with error handling
  private async loadExistingImages(images: Image[]): Promise<void> {
    try {
      // Process images sequentially to avoid overwhelming the server
      for (const image of images) {
        try {
          await this.processExistingImage(image);
        } catch (error) {
          console.error(`Failed to load image: ${image.url}`, error);
          // Add fallback image instead of crashing
          this.addFallbackImage(image, this.joinURL(this.escalasURI, image.url));
        }
      }
    } catch (error) {
      console.error('Error loading existing images:', error);
      this.toastr.error('Error al cargar imágenes existentes', 'Error');
    }
  }

  private async processExistingImage(image: Image): Promise<void> {
    try {
      const imageUrl = this.joinURL(this.escalasURI, image.url);
      const img = await fetch(imageUrl);
      
      if (!img.ok) {
        throw new Error(`HTTP ${img.status}: ${img.statusText}`);
      }
      
      const contentLength = img.headers.get("Content-Length");
      const base = await this.imageService.getBase64ImageFromUrl(imageUrl);

      console.log('image ===> ', image);

      if (image.content_type?.includes('image')) {
        this.uploadedFiles.push({
          name: image.url?.split('/').pop() || 'unknown',
          data: base as string,
          size: Number(contentLength) || 0,
          type: image.content_type || 'image/jpeg',
          id: image.id,
          isExisting: true
        });

        this.existingImages.push({
          name: image.url?.split('/').pop() || 'unknown',
          data: base as string,
          size: Number(contentLength) || 0,
          type: image.content_type || 'image/jpeg',
          id: image.id,
          isExisting: true
        });
      }
    } catch (error) {
      console.error(`Error processing image ${image.url}:`, error);
      throw error; // Re-throw to be handled by caller
    }
  }

  async loadTypes(id: number) {
    try {
      this.dropdownList = [];
      this.selectedItems = [];
      
      if (id == 3) {
        await this.loadSections();
      } else if (id == 4) {
        await this.loadSections();
      } else if (id == 5) {
        await this.loadFamilies();
      }
    } catch (error) {
      console.error('Error loading types:', error);
      this.toastr.error('Error al cargar los tipos', 'Error');
    }
  }

  async loadSections() {
    this.loadingIds = true;
    
    // Get campus IDs for filtering - ensure we have valid IDs
    // Try both campus_id and id properties in case the structure varies
    const campusIds = (this.campuses || [])
      .map((item: Campus) => item.campus_id || (item as any).id)
      .filter((id): id is number => id !== undefined && id !== null && !Number.isNaN(id));
    
    console.log('loadSections - Campuses:', this.campuses);
    console.log('loadSections - Extracted campus IDs:', campusIds);
    
    if (campusIds.length === 0) {
      console.error('No campuses available - cannot load sections');
      this.toastr.warning('No se han cargado los campus. Por favor, recarga la página.', 'Advertencia');
      this.loadingIds = false;
      return;
    }
    
    const payload: any = { 
      per_page: 600, 
      page: 1, 
      campus_id: campusIds
    };
    
    console.log('loadSections - API payload:', payload);
    
    this.subscriptions.add(
      this.escolarService.getSections(payload).subscribe({
        next: (sections: ServiceResponse<Section[]>) => {
          // API already filters by campus_id, use the data directly
          this.sections = sections.data;
          
          // Build dropdown list from sections
          this.dropdownList = [];
          for (const item of this.sections) {
            this.dropdownList.push({ 
              item_id: item.section_id, 
              item_text: `${item?.section || ''} ${item?.grade || ''} ${item?.group || ''}`
            });
          }
          
          if (this.notice) {
            this.loadSelectedItems(this.notice);
          }
          this.loadingIds = false;
        },
        error: (error: HttpError) => {
          this.toastr.error('Error al cargar las secciones', 'Error');
          console.error('Error loading sections:', error);
          this.loadingIds = false;
        }
      })
    );
  }

  async loadFamilies() {
    this.loadingIds = true;
    
    // Get campus IDs for filtering - ensure we have valid IDs
    // Try both campus_id and id properties in case the structure varies
    const campusIds = (this.campuses || [])
      .map((item: Campus) => item.campus_id || (item as any).id)
      .filter((id): id is number => id !== undefined && id !== null && !Number.isNaN(id));
    
    console.log('loadFamilies - Campuses:', this.campuses);
    console.log('loadFamilies - Extracted campus IDs:', campusIds);
    
    if (campusIds.length === 0) {
      console.error('No campuses available - cannot load families');
      this.toastr.warning('No se han cargado los campus. Por favor, recarga la página.', 'Advertencia');
      this.loadingIds = false;
      return;
    }
    
    const payload: any = { 
      per_page: 1000, 
      page: 1, 
      campus_id: campusIds
    };
    
    console.log('loadFamilies - API payload:', payload);
    
    this.subscriptions.add(
      this.escolarService.getFamilies(payload).subscribe({
        next: (families: ServiceResponse<Family[]>) => {
        // API already filters by campus_id, use the data directly
        this.families = families.data;
        
        // Clear and rebuild dropdown list
        this.dropdownList = [];
        for (const item of this.families) { 
          this.dropdownList.push({ item_id: item.family_id, item_text: item.name }); 
        }
        
        this.loadingIds = false;
        if (this.notice) {
          this.loadSelectedItems(this.notice);
        }    
        },
        error: (error: HttpError) => {
          this.toastr.error('Error al cargar las familias', 'Error');
          console.error('Error loading sections', error);
          this.loadingIds = false;
        }
      })
    );
  }

  loadForm(): void {
    this.noticeForm = this.fb.group({
      notice_id: [''],
      title: ['', [Validators.required]],
      description: [''],
      notify: [true, [Validators.required]],
      campus_id: ['', [Validators.required]],
      live: [true, [Validators.required]],
      generic_type: [1, [Validators.required]],
      generic_id: [],
      files: [''],
      images: [''],
      school_id: [this.school?.school_id, [Validators.required]],
      notice_type: [''],
      published_at_date: [new Date().toISOString().split('T')[0]],
      published_at_time: [new Date().toISOString().split('T')[1].split('.')[0]],
    });
  }

  /**
   * Load school_id from encrypted localStorage
   */
  private async loadUserSchoolId(): Promise<void> {
    try {
      const userData = await this.secureStorage.getItem('user');
      if (userData) {
        const user = JSON.parse(userData);
        if (user?.school_id) {
          this.noticeForm.patchValue({
            school_id: user.school_id
          });
          console.log('School ID loaded from encrypted storage:', user.school_id);
        } else {
          console.warn('No school_id found in user data');
        }
      }
    } catch (error) {
      console.error('Error loading school_id from encrypted storage:', error);
    }
  }

  async onFileChange(pFileList: FileList | File[] | Event): Promise<void> {
    console.log("FILES ===> ", pFileList);

    let fileList: File[] = [];
    
    if (pFileList instanceof Event) {
      const target = pFileList.target as HTMLInputElement;
      if (target?.files) {
        fileList = Array.from(target.files);
      }
    } else if (pFileList instanceof FileList) {
      fileList = Array.from(pFileList);
    } else if (Array.isArray(pFileList)) {
      fileList = pFileList;
    }

    // Process each file with secure validation
    for (const file of fileList) {
      try {
        // Use FileValidationService for comprehensive security validation
        const validationResult = await this.fileValidationService.validateFile(file);
        
        if (!validationResult.isValid) {
          this.toastr.error(
            `El archivo <b>${file.name}</b><br>${validationResult.errors.join('<br>')}`, 
            'Error de Seguridad',
            {
              timeOut: 5000,
              closeButton: true,
              enableHtml: true,
              tapToDismiss: true
            }
          );
          continue; // Skip this file and continue with next
        }

        // File passed validation, process it
        await this.processValidFile(file);

      } catch (error) {
        console.error('Error validating file:', error);
        this.toastr.error(
          `Error al validar el archivo <b>${file.name}</b>`,
          'Error',
          {
            timeOut: 3000,
            closeButton: true,
            enableHtml: true
          }
        );
      }
    }
  }

  private async processValidFile(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          if (e.target?.result) {
            const base64String = e.target.result;
            const fileName = file.name;
          
            // Update size tracking
            this.totalSize += file.size / (1024 * 1024);
            this.usedPercentage = ((this.totalSize / this.maxCapacity) * 100);
            
            // Add to files array
            this.files.push({ 
              name: fileName, 
              type: file.type, 
              data: base64String, 
              size: file.size, 
              content_type: file.type 
            });
            
            // Add to uploaded files if it's an image
            if (file.type.includes('image')) {
              this.uploadedFiles.push({
                name: fileName,
                type: file.type,
                data: base64String,
                size: file.size,
                content_type: file.type
              });
            }
          }          // Update form
          this.noticeForm.patchValue({
            files: this.files,
            images: this.uploadedFiles
          });
          
          resolve();
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = () => {
        this.toastr.error('Error al cargar el archivo', 'Error', {
          timeOut: 3000,
          closeButton: true,
          enableHtml: true
        });
        reject(new Error('FileReader error'));
      };

      reader.readAsDataURL(file);
    });
  }

  removeFile(file: FileUpload): void {
    this.files = this.files.filter(f => f.name !== file.name);
    this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);
    this.totalSize -= file.size / (1024 * 1024);
    this.usedPercentage = ((this.totalSize / this.maxCapacity) * 100);
    this.noticeForm.patchValue({
      files: this.files,
      images: this.files
    });
    this.store.deleteImageNotice(this.notice!.notice_id, file.id).subscribe({
      next: (data: DeleteResponse) => {
        this.toastr.success('Archivo eliminado correctamente', 'Éxito');
        console.log("FILE DELETED ===> ", data);

      },
      error: (error: HttpError) => {
        this.toastr.error('Error al eliminar el archivo', 'Error');
      }
    });
  }

  noticePublish(): void {
    const generic_id: number[] = this.selectedItems.map((item: DropdownItem) => item.item_id);
    
    // Safe array access with proper validation
    const campus_id = this.campuses.length > 0 ? this.campuses[0].campus_id : null;
    
    this.noticeForm.patchValue({
      campus_id: campus_id,
      files: this.files,
      generic_id: generic_id.join(',')
    });

    console.log("NOTICE FORM READY ===> ", this.noticeForm.value);

    this.noticeForm.patchValue({
      images: []
    });

    if (this.noticeForm.invalid) {
      this.toastr.error('Por favor, llena todos los campos requeridos', 'Error');
      return;
    }

    
    this.noticeData.emit(this.noticeForm.value);
  }

  deleteNotice(): void {
    this.store.deleteNotice(this.notice!.notice_id).subscribe({
      next: (data: DeleteResponse) => {
        this.toastr.success('Aviso eliminado correctamente', 'Éxito');
        this.router.navigate(['/notices/bulletins']);
      },
      error: (error: HttpError) => {
        this.toastr.error('Error al eliminar el aviso', 'Error');
      }
    });
  }

  openModalImageGenerator(): void {
    if (this.modalImageGenerator && this.modalImageGeneratorTemplate) {
      this.modalImageGenerator.openModal(this.modalImageGeneratorTemplate);
    }
  }

  // ✅ Helper method to add fallback image when loading fails
  private addFallbackImage(image: Image, originalUrl: string): void {
    try {
      const fallbackImage = {
        name: image.url?.split('/').pop() || 'imagen',
        data: 'https://via.placeholder.com/400x300/f5f5f5/999999?text=Imagen+no+disponible',
        size: 0,
        type: image.content_type || 'image/jpeg',
        id: image.id,
        isExisting: true,
        hasError: true,
        originalUrl: originalUrl
      };
      
      this.existingImages.push(fallbackImage);
      
      if (image.content_type?.includes('image')) {
        this.uploadedFiles.push(fallbackImage);
      }
      
      console.log('Added fallback image for:', image.url);
    } catch (error) {
      console.error('Error adding fallback image:', error);
    }
  }

  // ✅ FIXED: Implement OnDestroy to prevent memory leaks
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // Required by ng-multiselect-dropdown interface
  onItemSelect(item: any): void {

  }
  
  // Required by ng-multiselect-dropdown interface  
  onSelectAll(items: any): void {

  }

}
